import { render, staticRenderFns } from "./myText.vue?vue&type=template&id=b2d37b0e&scoped=true"
import script from "./myText.vue?vue&type=script&lang=js"
export * from "./myText.vue?vue&type=script&lang=js"
import style0 from "./myText.vue?vue&type=style&index=0&id=b2d37b0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d37b0e",
  null
  
)

export default component.exports